<template>
  <BModal
    active
    has-modal-card
    @close="() => $router.push({ name: 'Employees' })"
  >
    <form
      class="modal-card"
      @submit.prevent="create"
    >
      <header class="modal-card-head">
        <p class="modal-card-title has-text-primary">
          Nuevo empleado
        </p>
        <button
          type="button"
          class="delete"
          @click="closeModal()"
        />
      </header>
      <section class="modal-card-body">
        <NewEmployee :loading="loading" />
      </section>
      <footer class="modal-card-foot">
        <RouterLink
          class="button"
          :to="{ name: 'Employees' }"
        >
          Cerrar
        </RouterLink>

        <button
          type="submit"
          class="button is-primary"
        >
          Crear empleado
        </Button>
      </footer>
    </form>
  </BModal>
</template>

<script>
export default {
  name: 'EmployeePush',
  components: {
    NewEmployee: () => import(/* webpackChunkName: "new-employee" */ '@/components/Admin/Employee/New.vue'),
  },
  data() { return { loading: false }; },
  methods: {
    closeModal() {
      this.$router.push({ name: 'Employees' });
    },
    async create(event) {
      event.stopPropagation();
      this.loading = true;
      try {
        await this.$store.dispatch('employees/create');
        this.$success({ message: 'Empleado creado exitosamente' });
        this.$router.push({ name: 'Employees' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
form {
  width: auto;
}
</style>
